import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./EventItem.module.css";

import Button from "shared/Button";

/**
 * Interactive component.
 * Displays information about an event in the EventsList.
 */
export function EventItem({ eventInfo, onClick, onGroupClick }) {
  return (
    <li className={styles.container}>
      {Object.entries(eventInfo).map(
        (pair) =>
          pair[0] !== "id" && (
            <p className={styles[pair[0]]}>
              <span
                className={classNames({
                  [styles.link]: pair[0] === "group" && onGroupClick,
                })}
                onClick={pair[0] === "group" ? onGroupClick : null}
              >
                {typeof pair[1] === "boolean"
                  ? pair[1]
                    ? "Active"
                    : "Inactive"
                  : String(pair[1])}
              </span>
            </p>
          )
      )}

      <div className={styles.item}>
        <Button
          type="button"
          className={styles.detailsBtn}
          onClick={onClick}
          size="small"
        >
          Details
        </Button>
      </div>
    </li>
  );
}

EventItem.propTypes = {
  /**
   * Object with the event's info.
   */
  eventInfo: PropTypes.shape({
    jobCode: PropTypes.string,
    name: PropTypes.string,
    group: PropTypes.string,
    status: PropTypes.bool,
  }),
  /**
   * Function called when details is clicked.
   */
  onClick: PropTypes.func,
  /**
   * Function called when the registered group is clicked.
   */
  onGroupClick: PropTypes.func,
};
